export enum ETypeDocument{
    invoice = 'FAC',
    creditNote = 'NCR',
    debitNote = 'NDB'
}